













































// vue
import { Component, Vue } from 'vue-property-decorator'

// Vuex
import { mapGetters } from 'vuex'
import { namespace } from 'vuex-class'

// componnents
import { PageHeader, AccordionFilters, ButtonExport } from '@/components'
import { TableListTaskSheets, FiltersListTaskSheet } from '@/components/taskSheet'

// models
import { BvModalEvent } from 'bootstrap-vue'
import { FilterTaskSheet, TaskSheetModel } from '@/models/taskSheet'

// libs
import { formatDate } from '@/utils/dateLibs'

// constants
import { getTextWorkCategory, getTextWorkType } from '@/constants'
import { TaskSheetService } from '@/services/taskSheet'

const taskSheetStore = namespace('taskSheet')

@Component({
  name: 'TaskSheetIndex',
  components: {
    PageHeader,
    TableListTaskSheets,
    FiltersListTaskSheet,
    AccordionFilters,
    ButtonExport
  },
  computed: {
    ...mapGetters('taskSheet', {
        filters: 'filters'
    })
  }
})
export default class TaskSheetIndex extends Vue {
  showModal = false
  title = 'Tareo'
  actionForm = 'save'
  idItemEdit: number|null = null
  forceFirstPage = false

  itemsExcel: TaskSheetModel[] = []
  headersExcel = [
    {
      key: 'date',
      sortable: true,
      label: 'Fecha',
      formatter: (value: string) => {
        return formatDate(value)
      }
    },
    {
      key: 'work_type',
      sortable: true,
      label: 'Tipo de trabajo',
      formatter: (value: number) => {
        return getTextWorkType(value)
      }
    },
    {
      key: 'work_category',
      sortable: true,
      label: 'Categoría Ocupacional',
      formatter: (value: number) => {
        return getTextWorkCategory(value)
      }
    },
    {
      key: 'headquarter.name',
      label: 'Sede'
    },
    {
      key: 'area.name',
      label: 'Area'
    },
    {
      key: 'subArea.name',
      label: 'Sub-Area'
    }
  ]

  items = [
    {
      text: 'Dashboard',
      to: { name: 'home' }
    },
    {
      text: 'Tareo',
      active: true
    }
  ]

  filters!: FilterTaskSheet

  @taskSheetStore.Action
  public changeFilters!: (filters: FilterTaskSheet) => true

  async getAllitems () {
    this.itemsExcel = await TaskSheetService.getAll(this.filters)
  }

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  search () {
    this.forceFirstPage = true
    setTimeout(() => {
      this.tableList.getTaskSheetsWithPagination()
    }, 500)
  }

  clean () {
    const filters: FilterTaskSheet = {
      dateStart: null,
      dateEnd: null,
      workType: null,
      headquarter: null,
      area: null,
      subarea: null,
      employee_id: null
    }
    this.changeFilters(filters)
  }

  get tableList (): Vue & { getTaskSheetsWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getTaskSheetsWithPagination: () => void }
  }
}
